module.exports = __webpack_public_path__ + "static/media/1_A1_11.3ed63f66.png";